module.exports = __webpack_public_path__ + "static/media/yellowhead-3.fa073a51.jpg";